import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalConfig } from './../modal/modal-config';
import { Component, Input } from '@angular/core';
import { Confirmation } from './confirmation';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent {

  @Input() body: Confirmation;

  faIcon = faCircleExclamation;

  constructor(private ngbActiveModal: NgbActiveModal) { }

  // Variable to set modal information
  public modalConfig: ModalConfig;
  ngOnInit(): void {
    this.modalConfig = {
      modalTitle: this.body.title,
      ...this.modalConfig,
    };
  }
  close(response: boolean) {
    this.ngbActiveModal.close(response);
  }
}
